// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@flip/App/SharedStyle/MyAccount/Details/MyAccountDetailsStyles";
import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { css } from "styled-components";

orderInformationStyles.mainInformationGridItem = {
    width: 12,
};
orderInformationStyles.mainInformationGridContainer = {
    gap: 5,
    offsetCss: css`
        row-gap: 15px;
    `,
};
orderInformationStyles.orderNumberGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
orderInformationStyles.orderDateGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
orderInformationStyles.poNumberGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};
orderInformationStyles.statusGridItem = {
    ...myAccountDetailsStyles.informationGridItem,
};

orderInformationStyles.orderNumberText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.text,
};
orderInformationStyles.orderDateText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.text,
};
orderInformationStyles.poNumberText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.text,
};
orderInformationStyles.statusText = {
    ...myAccountDetailsStyles.informationHeadingAndText?.text,
};

orderInformationStyles.orderApprovalDetailsShippingInformation = {
    shippingCarrierText: {
        ...myAccountDetailsStyles.informationHeadingAndText?.text,
    },
    shippingDateRequestedText: {
        ...myAccountDetailsStyles.informationHeadingAndText?.text,
    },
    shippingServiceText: {
        ...myAccountDetailsStyles.informationHeadingAndText?.text,
    },
};
